import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

import { useIsHomeHealthWorkplace } from "./useIsHomeHealthWorkplace";

export function useShowInHomeLockToggle() {
  const isInHomeLockEnabled = useCbhFlag(CbhFeatureFlag.IN_HOME_LOCK_ENABLED, {
    defaultValue: false,
  });
  const isHomeHealthWorkplace = useIsHomeHealthWorkplace();

  return isInHomeLockEnabled && isHomeHealthWorkplace;
}
